import VacationPlan from "../vue/VacationPlan/VacationPlan.vue";
import Vue from "vue";

import VCalendar from "v-calendar";
import { api } from "../API";
import { initHotelGrid } from "../components/hotelGrid";

Vue.use(VCalendar, {
  locales: {
    he: {
      firstDayOfWeek: 1,
      masks: {
        L: "DD-MM-YYYY"
      }
    }
  }
});

export default {
  init() {
    window.eventBus = new Vue();

    new Vue({
      el: "#vacation-plan",
      components: { VacationPlan },
      template: "<VacationPlan />"
    });

    if ($("input[type=hidden]#raw-data").length) {
      const isMobile = $(window).width() <= 767;
      let packagesData = JSON.parse($("input[type=hidden]#raw-data").val());
      let isLoading = false;
      const theLoader = isMobile
        ? $(".packages-mobile-container")
        : $(".packages-desktop-container");

      const isComplete = function() {
        return packagesData.page >= packagesData.total_pages;
      };
      const showLoader = function(emptyPageLoaderHeightFix) {
        if (emptyPageLoaderHeightFix) {
          $(".packages-mobile-container")
            .parent()
            .find(".center.center-loader")
            .addClass("emptypage");
        }
        $(".packages-mobile-container")
          .parent()
          .find(".center.center-loader")
          .css("display", "flex");
      };
      const hideLoader = function() {
        $(".packages-mobile-container")
          .parent()
          .find(".center.center-loader")
          .hide();
        if (
          $(".packages-mobile-container")
            .parent()
            .find(".center.center-loader")
            .hasClass("emptypage")
        ) {
          $(".packages-mobile-container")
            .parent()
            .find(".center.center-loader")
            .removeClass("emptypage");
        }
      };

      if (isComplete()) {
        hideLoader();
      }

      // if ( window.history.replaceState ) {
      //   window.history.replaceState( null, null, window.location.href );
      // }

      const loadMorePackages = function(
        forceLoadingComplete = false,
        emptyPageLoaderHeightFix = false
      ) {
        if (!forceLoadingComplete && (isComplete() || isLoading)) {
          return;
        }

        isLoading = true;
        const isMobile = $(window).width() <= 767;
        showLoader(!isMobile && emptyPageLoaderHeightFix);
        // ajax call
        packagesData.page = packagesData.page + 1;

        api
          .queryVacationPackages(packagesData)
          .then(response => {
            isLoading = false;
            hideLoader();

            const theContainer = isMobile
              ? $(".packages-mobile-container")
              : $(".packages-desktop-container");
            if (isMobile) {
              theContainer.append(response.html);
            } else {
              theContainer.append(response.html);
            }

            setTimeout(() => {
              initHotelGrid();
            }, 0);
          })
          .catch(err => {
            isLoading = false;
            hideLoader();
          });
      };

      $(window).on("scroll", function() {
        const scrollTop = $(this).scrollTop();
        const theContainer = isMobile
          ? $(".packages-mobile-container")
          : $(".packages-desktop-container");
        let containerOffset =
          theContainer.offset().top +
          theContainer.outerHeight() -
          window.innerHeight;

        if (isMobile) {
          containerOffset -= 100;
        }

        if (scrollTop >= containerOffset) {
          loadMorePackages();
        }
      });

      // Sorting
      const SubmitSorting = function(selectBox) {
        const value = $(selectBox).val();
        packagesData.page = 1;
        const isMobile = $(window).width() <= 767;
        const theContainer = isMobile
          ? $(".packages-mobile-container")
          : $(".packages-desktop-container");
        theContainer.html("");

        if ($(selectBox).hasClass("sorting-by-rating")) {
          packagesData.sort_rating = value;
        } else if ($(selectBox).hasClass("sorting-by-price")) {
          packagesData.sort_price = value;
        }

        loadMorePackages(true, true);
      };
      $(".sorting-wrap select.sorting-box").on("change", function() {
        SubmitSorting(this);
      });

      $(window).on("click", () => {
        if (
          $(".sorting-wrap ul#sorting-by-input-list").css("display") !== "none"
        ) {
          $(".sorting-wrap ul#sorting-by-input-list").slideToggle(300);
        }
      });
      $(".sorting-wrap input#sorting-by-input").on("click", function(event) {
        event.stopPropagation();
        $(".sorting-wrap ul#sorting-by-input-list").slideToggle(300);
      });
      $(".sorting-wrap ul#sorting-by-input-list").on("click", function(event) {
        event.stopPropagation();
      });
      $(".sorting-wrap ul#sorting-by-input-list li").on("click", function(
        event
      ) {
        event.stopPropagation();
        $(".sorting-wrap ul#sorting-by-input-list").slideToggle(300);
        $(".sorting-wrap input#sorting-by-input").val(
          $(this)
            .find("span")
            .html()
        );
        SubmitSorting($(this).attr("data-val"));
      });
    }
  }
};
